import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import TenantInvitationCreateDialog from "@/v2-backoffice-client/tenant/invitation/create/TenantInvitationCreateDialog"

export type TenantInvitationCreateButtonProps = ButtonProps & {
  tenantId: number
}

function TenantInvitationCreateButton(
  props: TenantInvitationCreateButtonProps,
) {
  const { tenantId, onClick, children, ...buttonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Invite user"}
      </Button>

      <TenantInvitationCreateDialog
        tenantId={tenantId}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default TenantInvitationCreateButton
